import Showroom from 'assets/png/links/img-showroom.png'
import Remuneracao from 'assets/png/links/img-remuneracao.png'
import Simplus from 'assets/png/links/img-simplus.png'
import Trade from 'assets/png/links/img-trade.png'
import Whatsapp from 'assets/png/links/img-whatsapp.png'
import Connect from 'assets/png/links/img-connect.png'
import Cadastro from 'assets/png/links/img-cadastro.png'
import Despesas from 'assets/png/links/img-despesas.png'

export interface LinkCardInterface {
  title: string
  description: string
  link: string
  image: string
}

export const links: LinkCardInterface[] = [
  {
    title: 'Showroom virtual',
    description: 'Ferramenta de trade para consultar o portfólio',
    link: 'https://showroom.havaianas.com/login',
    image: Showroom
  },
  {
    title: 'Remuneração variável',
    description: 'Consulte aqui sua remuneração variável',
    link: 'https://go.achievemore.com.br',
    image: Remuneracao
  },
  {
    title: 'Simplus',
    description: 'Ferramenta com dados cadastrais dos materiais',
    link: 'https://prod.simplustec.com.br/#/',
    image: Simplus
  },
  {
    title: 'Trade Informa',
    description: 'Confira as novidades de Trade',
    link: '',
    image: Trade
  },
  {
    title: 'Grupo do Whatsapp',
    description: 'Receba informações de Trade via WhatsApp',
    link: '',
    image: Whatsapp
  },
  {
    title: 'Connect',
    description: 'Banco de ativos digitais da Havaianas',
    link: 'https://connect.havaianas.com/',
    image: Connect
  },
  {
    title: 'Solicitação de cadastro',
    description: 'Registre ou atualize dados de clientes',
    link: '',
    image: Cadastro
  },
  {
    title: 'Mapa de despesas',
    description: 'Registre mensalmente seus gastos para reembolso',
    link: 'https://www.portalalpargatas.com.br/Site/Portal/Home/HomeVazio.aspx?pa_cd_sist_menu=MDEV&pa_cd_grup_menu=MDEV',
    image: Despesas
  }
]
